import React from 'react';
import { Svg, Path } from 'react-native-svg';

export const StarFace = ({ color = '#333333', size = 28 }) => (
    <Svg
        width={size}
        height={size}
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <Path
            d="M19.8292 20.1173C20.8206 19.0668 21.3066 17.8838 21.4612 17.2653L18.9388 16.6347C18.8768 16.8828 18.5827 17.6499 17.9383 18.3327C17.3289 18.9785 16.4114 19.55 15 19.55C13.5886 19.55 12.6712 18.9785 12.0617 18.3327C11.4173 17.6499 11.1232 16.8828 11.0612 16.6347L8.53883 17.2653C8.69346 17.8838 9.1794 19.0668 10.1708 20.1173C11.1972 21.2048 12.7714 22.15 15 22.15C17.2286 22.15 18.8028 21.2048 19.8292 20.1173Z"
            fill={color}
        />
        <Path
            d="M14.0345 10.9828L11.6521 10.6687L10.6173 8.5L9.58238 10.6687L7.2 10.9828L8.9428 12.6372L8.50527 15L10.6173 13.8537L12.7292 15L12.2917 12.6372L14.0345 10.9828Z"
            fill={color}
        />
        <Path
            d="M23.1345 10.9828L20.7521 10.6687L19.7173 8.5L18.6824 10.6687L16.3 10.9828L18.0428 12.6372L17.6053 15L19.7173 13.8537L21.8292 15L21.3917 12.6372L23.1345 10.9828Z"
            fill={color}
        />
        <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M28 15C28 7.8203 22.1797 2 15 2C7.8203 2 2 7.8203 2 15C2 22.1797 7.8203 28 15 28C22.1797 28 28 22.1797 28 15ZM15 4.6C20.7438 4.6 25.4 9.25624 25.4 15C25.4 20.7438 20.7438 25.4 15 25.4C9.25624 25.4 4.6 20.7438 4.6 15C4.6 9.25624 9.25624 4.6 15 4.6Z"
            fill={color}
        />
    </Svg>
);
